module.exports = __webpack_public_path__ + "media/application/images/svgs/minimize-2-92ba7ce4701c37b015e6c2105c02dfce.svg";